import { defineStore } from "pinia";
import { warehouseService } from "@/_services";

export const warehouseStore = defineStore("warehouse", {
  state: () => ({
    warehouses: null,
    warehousesExport: null,
    warehouse: null,
    warehouseCreated: null,
    warehouseUpdated: null,
    warehouseDeleted: null,
    error: null,
  }),

  actions: {
    getWarehouses(pagination, query, sort) {
      this.error = null;
      warehouseService
        .getWarehouses(pagination, query, sort)
        .then((result) => {
          this.warehouses = result;
        })
        .catch((reason) => {
          this.error = reason;
        });
    },
    exportar(pagination, query, sort) {
      this.error = null;
      this.warehousesExport = null;
      return warehouseService
        .exportar(pagination, query, sort)
        .then((result) => {
          this.warehousesExport = result;
          return result;
        })
        .catch((reason) => {
          this.error = reason;
          throw reason;
        });
    },
    getWarehouseById(warehouse_id) {
      this.error = null;
      this.warehouse = null;
      warehouseService
        .getWarehouseById(warehouse_id)
        .then((result) => {
          this.warehouse = result;
        })
        .catch((reason) => {
          this.error = reason;
        });
    },
    createWarehouse(data) {
      this.error = null;
      this.warehouseCreated = null;
      warehouseService
        .createWarehouse(data)
        .then((result) => {
          this.warehouseCreated = result;
        })
        .catch((reason) => {
          this.error = reason;
        });
    },
    updateWarehouse(data, warehouse_id) {
      this.error = null;
      this.warehouseUpdated = null;
      warehouseService
        .updateWarehouse(data, warehouse_id)
        .then((result) => {
          this.warehouseUpdated = result;
        })
        .catch((reason) => {
          this.error = reason;
        });
    },
    deleteWarehouse(warehouse_ids) {
      this.error = null;
      this.warehouseDeleted = null;
      warehouseService
        .deleteWarehouse(warehouse_ids)
        .then((result) => {
          this.warehouseDeleted = result;
        })
        .catch((reason) => {
          this.error = reason;
        });
    },
  },
});
